import { Component } from 'preact';

class VersionMenu extends Component {
  render(props, state) {
    const apps = props.appVersions.map(function(a) {
      return (
       <li><strong>{a.name}</strong><span className={"overflow-ellipsis"}>{a.version}{!!a.environment? ' - ' + a.environment : ''}</span></li>
      );
    });
		return (
      <div id="version-menu-container">
        <button onClick={() => props.toggleVersionMenu()}><i className={"fas fa-ellipsis-h"}></i></button>

        <div onClick={() => props.toggleVersionMenu()} id="version-menu" className={props.versionMenuOpen? "" : "hidden"}>
         <span className="header">System Information</span>
         <ul>
          {apps}
         </ul>
         <span className="footer">Covered by U.S. Patent No. 9,020,842</span>
        </div>
      </div>
		);
	}
}

export {VersionMenu};



// WEBPACK FOOTER //
// ./components/sidebar/versionmenu.js